var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "780px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("note_add")]),
              _vm._v(
                " Nueva Solicitud " +
                  _vm._s(
                    _vm.horas_disponibles === null
                      ? ""
                      : "Tiene " +
                          _vm.horas_disponibles.toFixed(2) +
                          " horas disponibles"
                  ) +
                  "\n\t\t\t\t"
              ),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-container",
                    { staticClass: "pt-0", attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "Tipo de papeleta",
                                  items: _vm.permisos,
                                  rules: _vm.$validate(["required"]),
                                  "item-value": "id",
                                  "item-text": "descripcion",
                                  required: "",
                                  autofocus: "",
                                  disabled: _vm.permiso_detalles.length > 0
                                },
                                model: {
                                  value: _vm.permiso.id_tipo_permiso,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.permiso,
                                      "id_tipo_permiso",
                                      $$v
                                    )
                                  },
                                  expression: "permiso.id_tipo_permiso"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Motivo",
                                  disabled: _vm.permiso_detalles.length > 0,
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.permiso.motivo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.permiso, "motivo", $$v)
                                  },
                                  expression: "permiso.motivo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.horas_disponibles > 0
                        ? _c("h4", [_vm._v("Detalle de papeleta")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha salida",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.validarPermiso()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde", $$v)
                                  },
                                  expression: "form.fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha salida",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.validarPermiso()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_hasta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta", $$v)
                                  },
                                  expression: "form.fecha_hasta"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.horas_disponibles > 0
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      ref: "menu_desde",
                                      attrs: {
                                        "close-on-content-click": false,
                                        "nudge-right": 40,
                                        "return-value": _vm.time_hora_desde,
                                        lazy: "",
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "full-width": "",
                                        "max-width": "290px",
                                        "min-width": "290px"
                                      },
                                      on: {
                                        "update:returnValue": function($event) {
                                          _vm.time_hora_desde = $event
                                        },
                                        "update:return-value": function(
                                          $event
                                        ) {
                                          _vm.time_hora_desde = $event
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        label: "Hora desde",
                                                        "prepend-icon":
                                                          "access_time",
                                                        readonly: "",
                                                        rules: _vm.$validate([
                                                          "required"
                                                        ])
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.time_hora_desde,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.time_hora_desde = $$v
                                                        },
                                                        expression:
                                                          "time_hora_desde"
                                                      }
                                                    },
                                                    on
                                                  )
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1790337629
                                      ),
                                      model: {
                                        value: _vm.menu2_hora_desde,
                                        callback: function($$v) {
                                          _vm.menu2_hora_desde = $$v
                                        },
                                        expression: "menu2_hora_desde"
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _vm.menu2_hora_desde
                                        ? _c("v-time-picker", {
                                            attrs: {
                                              format: "24hr",
                                              "allowed-minutes":
                                                _vm.allowedStep,
                                              "full-width": ""
                                            },
                                            on: {
                                              "click:minute": function($event) {
                                                return _vm.$refs.menu_desde.save(
                                                  _vm.time_hora_desde
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.time_hora_desde,
                                              callback: function($$v) {
                                                _vm.time_hora_desde = $$v
                                              },
                                              expression: "time_hora_desde"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      ref: "menu_hasta",
                                      attrs: {
                                        "close-on-content-click": false,
                                        "nudge-right": 40,
                                        "return-value": _vm.time_hora_hasta,
                                        lazy: "",
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "full-width": "",
                                        "max-width": "290px",
                                        "min-width": "290px"
                                      },
                                      on: {
                                        "update:returnValue": function($event) {
                                          _vm.time_hora_hasta = $event
                                        },
                                        "update:return-value": function(
                                          $event
                                        ) {
                                          _vm.time_hora_hasta = $event
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        label: "Hora desde",
                                                        "prepend-icon":
                                                          "access_time",
                                                        readonly: "",
                                                        rules: _vm.$validate([
                                                          "required"
                                                        ])
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.time_hora_hasta,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.time_hora_hasta = $$v
                                                        },
                                                        expression:
                                                          "time_hora_hasta"
                                                      }
                                                    },
                                                    on
                                                  )
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        2556714433
                                      ),
                                      model: {
                                        value: _vm.menu2_hora_hasta,
                                        callback: function($$v) {
                                          _vm.menu2_hora_hasta = $$v
                                        },
                                        expression: "menu2_hora_hasta"
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _vm.menu2_hora_hasta
                                        ? _c("v-time-picker", {
                                            attrs: {
                                              format: "24hr",
                                              "allowed-minutes":
                                                _vm.allowedStep,
                                              "full-width": ""
                                            },
                                            on: {
                                              "click:minute": function($event) {
                                                return _vm.$refs.menu_hasta.save(
                                                  _vm.time_hora_hasta
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.time_hora_hasta,
                                              callback: function($$v) {
                                                _vm.time_hora_hasta = $$v
                                              },
                                              expression: "time_hora_hasta"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.horas_disponibles > 0
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        loading: _vm.loading
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.addPermisoDetalle()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("add")]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tAdicionar\n\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.permiso_detalles.length > 0
                                    ? _c("span", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\tTotal horas solicitadas: " +
                                            _vm._s(
                                              _vm.horas_solicitadas.toFixed(2)
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _vm.horas_solicitadas > _vm.horas_disponibles
                                    ? _c(
                                        "v-alert",
                                        {
                                          attrs: { value: true, type: "error" }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\tSuperó sus horas disponibles\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.horas_disponibles > 0
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      items: _vm.permiso_detalles,
                                      "hide-actions": "",
                                      headers: _vm.headers
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$moment(
                                                          props.item.fecha_desde
                                                        )
                                                        .format("DD/MM/YYYY")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .$moment(
                                                          props.item.fecha_hasta
                                                        )
                                                        .format("DD/MM/YYYY")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.hora_desde
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.item.hora_hasta
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      (
                                                        _vm
                                                          .$moment(
                                                            props.item
                                                              .fecha_hasta +
                                                              " " +
                                                              props.item
                                                                .hora_hasta
                                                          )
                                                          .diff(
                                                            props.item
                                                              .fecha_desde +
                                                              " " +
                                                              props.item
                                                                .hora_desde,
                                                            "minutes"
                                                          ) / 60
                                                      ).toFixed(2)
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "error",
                                                        icon: "",
                                                        title: "Eliminar"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.deletePermisoDetalle(
                                                            props.item.delete
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("delete")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1880487892
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.horas_disponibles > 0
                ? _c(
                    "v-card-actions",
                    [
                      _c(
                        "small",
                        { staticClass: "error--text text-required" },
                        [_vm._v("* Los campos son obligatorios")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.close()
                            }
                          }
                        },
                        [
                          _c("v-icon", [_vm._v("cancel")]),
                          _vm._v(" " + _vm._s(_vm.$t("common.cancel")))
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            type: "submit",
                            disabled:
                              !_vm.permiso_detalles.length > 0 ||
                              _vm.horas_solicitadas > _vm.horas_disponibles,
                            loading: _vm.loading
                          }
                        },
                        [
                          _c("v-icon", [_vm._v("check")]),
                          _vm._v(
                            " \n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("common.save")) +
                              "\n\t\t\t\t\t"
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33be5911", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33be5911","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/AddSolicitud.vue
// module id = null
// module chunks = 